
// @ts-nocheck


export const localeCodes =  [
  "en",
  "no"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_b8607318",
      load: () => import("#nuxt-i18n/b8607318" /* webpackChunkName: "locale_en_46json_b8607318" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_7f672b1d",
      load: () => import("#nuxt-i18n/7f672b1d" /* webpackChunkName: "locale_no_46json_7f672b1d" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      _hreflang: "en",
      _sitemap: "en",
      files: [
        {
          path: "/home/wann/Development/vuenuxt/ordinator/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      _hreflang: "no",
      _sitemap: "no",
      files: [
        {
          path: "/home/wann/Development/vuenuxt/ordinator/i18n/locales/no.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "no",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    _hreflang: "en",
    _sitemap: "en",
    files: [
      {
        path: "/home/wann/Development/vuenuxt/ordinator/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    _hreflang: "no",
    _sitemap: "no",
    files: [
      {
        path: "/home/wann/Development/vuenuxt/ordinator/i18n/locales/no.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/